import React, { useEffect, useState } from "react";

import { Sidebar } from "primereact/sidebar";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";

import { useOverlayEscape } from "../../../common/fields/useOverlayPanelEscape";

const FiltersSheet = ({
  isFilterSheetVisible,
  allFields,
  filters,
  handleClose,
  onFilterChange,
}) => {
  const [selectedFilterOptions, setSelectedFilterOptions] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(null);

  // A Sidebar's own Escape handling ranks below a Dialog's, so inside a Dialog
  // (the certificate dialog's New download) Escape closed the Dialog: close the
  // sheet first, ahead of it.
  useOverlayEscape(isFilterSheetVisible, handleClose);

  useEffect(() => {
    setSelectedFilterOptions(filters);
    if (filters.length > 0) {
      setSelectedFilter(filters[0]);
    }
  }, [filters]);

  function handleApplyFilter() {
    onFilterChange(selectedFilterOptions);
    handleClose();
  }

  return (
    <Sidebar
      onHide={handleClose}
      visible={isFilterSheetVisible}
      position="bottom"
      style={{
        height: "70vh",
        borderRadius: "24px 24px 0px 0px",
        padding: 0,
      }}
      header={(props) => {
        return (
          <span style={{ fontSize: "2rem", fontWeight: "bold" }}>Filters</span>
        );
      }}
    >
      <div
        className="h-full relative"
        style={{ border: "1px solid rgba(2, 6, 12, 0.05)" }}
      >
        <main className="flex h-full">
          <div className="flex-1">
            {allFields.map((item) => {
              return (
                <li
                  key={item.id}
                  className={`px-4 p-3 relative`}
                  style={{
                    listStyle: "none",
                    fontWeight: "600",
                    fontSize: "18px",
                  }}
                  onClick={() => setSelectedFilter(item)}
                >
                  <div
                    className={
                      selectedFilter?.id === item.id ? "selected-li" : ""
                    }
                  />
                  {item.name}
                </li>
              );
            })}
          </div>
          <hr
            className=""
            style={{ border: "0.5px solid rgba(2, 6, 12, 0.05)", margin: 0 }}
          />
          <div
            className={`flex-1 pt-3 px-4 pb-5 flex flex-column gap-3 overflow-auto`}
          >
            {selectedFilter?.options ? (
              selectedFilter?.options?.map((option) => {
                const parentFilter = selectedFilterOptions?.find(
                  (item) => item.id === selectedFilter?.id
                );

                const checked = parentFilter?.values?.find(
                  (item) => item === option.id
                );

                return (
                  <div key={option.id}>
                    <Checkbox
                      inputId="ingredient1"
                      name="pizza"
                      value={option.id}
                      onChange={(e) => {
                        const value = e.target.value;

                        const _filters = [...selectedFilterOptions];

                        const filterIndex = _filters.findIndex(
                          (item) => item.id === selectedFilter?.id
                        );

                        if (filterIndex === -1) {
                          _filters.push({
                            id: selectedFilter?.id,
                            options: selectedFilter?.options,
                            type: selectedFilter?.type,
                            name: selectedFilter?.name,
                            values: [value],
                          });
                        } else {
                          const updatedValues = checked
                            ? _filters[filterIndex].values.filter(
                                (v) => v !== value
                              )
                            : [..._filters[filterIndex].values, value];

                          _filters[filterIndex] = {
                            ..._filters[filterIndex],
                            values: updatedValues,
                          };
                        }
                        setSelectedFilterOptions(_filters);
                      }}
                      checked={!!checked}
                    />
                    <label htmlFor="ingredient1" className="ml-2">
                      {option.name}
                    </label>
                  </div>
                );
              })
            ) : (
              <div className=" flex align-items-center gap-2">
                <span
                  className="pi pi-info-circle"
                  style={{
                    fontSize: "2rem",
                    color: "var(--edexlms-primary-color)",
                  }}
                ></span>
                {!selectedFilter
                  ? "Please click the filter to choose an option."
                  : "No options available"}
              </div>
            )}
          </div>
        </main>
        <footer
          className="h-4rem fixed bottom-0 left-0 right-0 shadow-2 flex justify-content-end align-items-center"
          style={{ backgroundColor: "#ffffff" }}
        >
          <div className="flex  gap-2 align-items-center pr-2">
            <Button
              onClick={() => {
                setSelectedFilterOptions([]);
              }}
              outlined
            >
              Clear filters
            </Button>
            <Button onClick={handleApplyFilter}>Apply</Button>
          </div>
        </footer>
      </div>
    </Sidebar>
  );
};

export default FiltersSheet;
